import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_AKKU_SSO_URL,
  realm: process.env.REACT_APP_AKKU_SSO_RELAM,
  clientId: process.env.REACT_APP_AKKU_SSO_CLIENTID,
});

export default keycloak;